module.exports = "/_next/static/images/delivery_4-16ace40d93ca779d810ee5cb4b5c3962.png";